import { AdvancedTagMapping } from 'src/features/gateway-details/types';
import { ModalTableRowData } from '../types';
import { removeDynamicFields } from './remove-dynamic-fields';

export function getUpdatedFormValues(
  originalValues: AdvancedTagMapping,
  dataType: string,
  rowData: ModalTableRowData[]
) {
  const fieldsToRemove: string[] = [];

  rowData.forEach((row: ModalTableRowData) => {
    if ((dataType === 'BOOLEAN' && row.index > 1) || (dataType === 'FLOAT' && row.index > 0)) {
      fieldsToRemove.push(`value-${row.index}`);
      fieldsToRemove.push(`category-${row.index}`);
      fieldsToRemove.push(`name-${row.index}`);
    }
  });

  const updatedValues = removeDynamicFields(originalValues, fieldsToRemove);

  return updatedValues;
}
